import { TableOutlined } from '@ant-design/icons';
import React from 'react';
import type { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { ITableInputWidget } from './ITableInputWidget';
import { TableInputConfigSchema } from './TableInputWidget.validator';
import { TableInputWidgetComponent } from './TableInputWidgetComponent';
import { TableInputWidgetConfigComponent } from './TableInputWidgetConfigComponent';
import { TableInputWidgetPreview } from './TableInputWidgetPreview';
import { TableInputWidgetTranslationSchema } from './TableInputWidgetTranslationSchema';
import { createTableSchema } from './createTableSchema';
import { getTableInputVirtualColumnsReferences } from './expression/getTableInputVirtualColumnsReferences';
import { materializeTableInputWidgets } from './expression/materializeTableInputWidget';

/**
 * Tipo del componente Tabella contenitore di campi di Input.
 */
export const TableInputWidgetType: IWidgetType<ITableInputWidget> = {
  type: WidgetType.TableInput,
  mainType: WidgetMainType.Base,
  category: WidgetCategory.Advanced,
  name: 'Tabella di Input',
  icon: <TableOutlined />,
  hasValue: false,
  // getReference: getTableInputWidgetReference,
  materializeChildren: materializeTableInputWidgets,
  getParentVirtualReferences: getTableInputVirtualColumnsReferences,
  formComponent: TableInputWidgetComponent,
  createFormSchema: createTableSchema,
  configComponent: TableInputWidgetConfigComponent,
  configValidator: TableInputConfigSchema,
  previewComponent: TableInputWidgetPreview,
  translationSchema: TableInputWidgetTranslationSchema,
  configOptions: {
    removeCollapsePanel: true,
  },
  rules: [],
};
